// * DEPENDS.
import React from 'react';
import { useSelector } from 'react-redux';

// * CSS 
import '../CSS/Copyright.css'


const Copyright = () => {
    // handles hiding the comp when there is a gallery displayed
    const hide = useSelector(state => { return state.gallery.value});

    const currentYear = new Date().getFullYear();

    return (
        <div className="Copyright" style={{display: hide ? "none" : "flex"}}>
            <div className="Copyright__logo"></div>
            <div className="Copyright__copyContainer">
                <p id="disclaim" className="Copyright__copy">Copyright {currentYear} <br/> Audio Contractors LLC.</p>
                <p id="claim" className="copyContainer__copy">Code & Design by <a href="https://avantgov.club" target="_blank" rel="noreferrer">avantgov</a></p>
            </div>
        </div>
    );
};

export default Copyright;